
import { LevelProgressionMutationProps, MutationHooks } from './types';
import { useActivityMutation } from './useActivityMutation';
import { useProfileMutation } from './useProfileMutation';
import { useLessonMutation } from './useLessonMutation';

export const useLevelProgressionMutations = ({
  userId,
  selectedLesson
}: LevelProgressionMutationProps): MutationHooks => {
  const { activityMutation, getActivities } = useActivityMutation();
  const profileMutation = useProfileMutation(userId);
  const lessonMutation = useLessonMutation(userId);
  
  return { 
    lessonMutation, 
    profileMutation, 
    activityMutation, 
    getActivities 
  };
};
